"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.success.title': 'Konto aktywowane!',
    'activate.success.description': 'Twoje konto zostało pomyślnie aktywowane. Możesz teraz się zalogować i zacząć korzystać z IntHub.',
    'activate.success.message': 'Konto aktywowane pomyślnie!',
};
